let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iCAVc")).then(() => parcelRequire('lbmdH'));